export default "__VITE_ASSET__BbAWqttq__"